/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Cancel_Downgrade_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel scheduled downgrade" |
*
* @param {Sub_Dashboard_Cancel_Downgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_cancel_downgrade_title = /** @type {((inputs?: Sub_Dashboard_Cancel_Downgrade_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Cancel_Downgrade_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplantes Downgrade abbrechen")
	return /** @type {LocalizedString} */ ("Cancel scheduled downgrade")
});